<template>
  <crud-table
    create-route=""
    :columns="fields"
    vuex-prefix="application_log"
    create-role="Developer"
    :fetch-address="fetchAddress"
  >
    <template #cell(actions)="data">
      <table-action-buttons
        fa-title="فیلد"
        route="application-data"
        hidden-show-button
        hidden-edit-button
        :record-id="parseInt(applicationId)"
        hidden-delete-button
      >
        <template #extra-buttons>
          <router-link
            title="مشاهده"
            v-b-tooltip.hover
            :to="{
              name: 'applications.logs.show',
              params: { applicationId: applicationId, error: data.item.err },
            }"
          >
            <i class="mdi mdi-eye font-size-18 text-success"></i>
          </router-link>
        </template>
      </table-action-buttons>
    </template>
  </crud-table>
</template>

<script>
export default {
  props: {
    applicationId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    fetchAddress() {
      return `applications/${this.applicationId}/logs`;
    },
  },
  data() {
    return {
      fields: [
        {
          key: "err",
          sortable: false,
          label: "نام ارور",
        },
        {
          key: "count",
          sortable: false,
          label: "تعداد",
        },
      ],
    };
  },
};
</script>
